import { useEffect, useMemo } from "react";
import { Link, useParams, useSearchParams } from "react-router";
import { SessionPlayer } from "../components/SessionPlayer";
import { TopBar } from "../components/TopBar";
import { makeReplaySource } from "../sources/replaySource";
import { useManifestStore } from "../state/manifestStore";

export function SessionPage() {
  const { tenant, sessionId } = useParams();
  const [params] = useSearchParams();
  const mode = (params.get("mode") as "replay" | "live" | null) ?? "replay";
  const { manifest, ensureLoaded } = useManifestStore();
  useEffect(() => {
    ensureLoaded();
  }, [ensureLoaded]);

  const source = useMemo(() => {
    if (!manifest) return null;
    const byId = (id: string) => {
      const m = manifest.sessions.find((s) => s.id === id);
      if (!m) throw new Error(`session ${id} not in manifest`);
      return m.session_uri;
    };
    return makeReplaySource(byId);
  }, [manifest]);

  if (!manifest || !source || !sessionId || !tenant) {
    return (
      <div className="app-content">
        <p className="empty">Loading…</p>
      </div>
    );
  }

  const sm = manifest.sessions.find((s) => s.id === sessionId);
  return (
    <>
      <TopBar
        tenant={tenant}
        title={sm?.title ?? "Session"}
        crumbs={[
          { label: "Sessions", to: `/${tenant}/sessions` },
          { label: `${sessionId.slice(0, 16)}…` },
        ]}
      />
      <div className="app-content">
        <div className="session-nav">
          <Link to={`/${tenant}/sessions`}>← back to sessions</Link>
          <span className="meta-label session-mode">mode: {mode}</span>
        </div>
        <SessionPlayer sessionId={sessionId} source={source} />
      </div>
    </>
  );
}
